import { discountClass, percent } from '../lib/format';

interface Props {
  /** Percentual vs. Steam: negativo = mais barato lá no Youpin. */
  value: number | null | undefined;
}

/**
 * Comparação de preço com a Steam. Quando há desconto, o "OFF" vem num span
 * próprio para poder piscar — é o que puxa o olho na grade de cards.
 */
export function Discount({ value }: Props) {
  // Sem base de comparação (Steam ausente ou zerada) não há o que mostrar:
  // um traço solto ao lado do preço só polui.
  if (value === null || value === undefined) return null;
  const isOff = value < 0;
  return (
    <span className={`diff ${discountClass(value)}`}>
      {percent(value)}
      {isOff && <span className="off-tag"> OFF</span>}
    </span>
  );
}
